import { BaseApi } from './BaseApi';
import { CancelToken } from 'axios';

export default class CustomerApps extends BaseApi {
  public async getAllAsync(cancelToken?: CancelToken) {
    return await this.getListAsync<ICustomerApp>('customerApps', null, cancelToken);
  }
}
